import Footer from 'layout/footer';
import Header from 'layout/header';
import { Fragment } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import React, { useEffect, useMemo, useState } from "react";
import { loadFromLocalStorage } from '../../utils/LocalStorageUtils';
import HelpCenterEng from './component/helpcenterEng';
import HelpCenterHi from './component/helpcenterHi';

const HelpCenter = () => {
    const authData = loadFromLocalStorage("AUTH_DATA");

    const [languageData, setLanguageData] = useState(null);
    const selectLang = loadFromLocalStorage("SELECTLANGUAGE");
    const memoizedLanguageData = useMemo(() => selectLang?.language, [selectLang]);

    useEffect(() => {
        setLanguageData(memoizedLanguageData);
    }, [memoizedLanguageData]);

   return (
        <Fragment>
            <Container className="my-5" style={{ fontFamily: "Quicksand" }}>
                <Row>
                    <Col md={12}>
                        <Card>
                            {selectLang?.langCode == 'hi' ?
                                <HelpCenterHi />
                                :
                                <HelpCenterEng />
                            }
                        </Card>
                    </Col> 
                </Row>
            </Container>
        </Fragment>
    );
};


export default HelpCenter;
